<template>
  <div class="expandable-cell-section">
    <template v-for="(item, index) in list">
      <div v-if="$route.params.id == item.id" class="expandable-border-cell-wrapper"  :key="index">
        <template  v-for="(titem, tindex) in item.mes_list">
          <div class="expandable-border-cell">
            <div class="expandable-border-cell-preview"  :key="tindex">
              <div class="left-section">
                <div class="left-title">{{titem.title}}</div>
                <hr class="divider">
                <ol>
                  <li v-for="(xitem, xindex) in tindex == 0?titem.mes[1].text:titem.mes[0].text" :key="xindex">{{xitem}}</li>
                </ol>
              </div>
              <div class="right-section">
                <div class="inner" :style="{'background': 'url(@/assets/img/resources/uploads/' + titem.img + ') center center / auto 100% no-repeat scroll transparent'}"></div>
              </div>
            </div>
            <div class="flex-h-center mb14">
              <div class="slash header mr10"></div>
              <div class="header-title f22 purple-2 semibold">{{titem.title}}</div>
              <div class="slash header ml10"></div>
            </div>
            <img :alt="titem.title" v-lazy="require('@/assets/img/resources/uploads/' + titem.img)"
                 class="header-img alignnone size-medium wp-image-195">
            <template v-for="(xitem, xindex) in titem.mes">
              <div class="slash-subtitle-wrapper" :key="'x'+xindex" v-if="xitem.type != ''">
                <div class="slash"></div>
                <div class="slash"></div>
                <div class="slash-subtitle">{{xitem.type}}</div>
              </div>
              <ol>
                <li v-for="(nitem, nindex) in xitem.text" :key="nindex">{{nindex + 1}}.{{nitem}}</li>
              </ol>
            </template>
            <div id="pestadvice_div_getMesDetail_handler" :data-fuget="titem.fuget_id" class="drawer-handler" @click="getMesDetail(tindex, titem.title)">
              <div class="stretched-out"></div>
              <img src="@/assets/img/resources/icon-drawer.svg" class="icon-drawer"></div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
  import '@/styles/pest_wiki/global2.less';
  import '@/styles/pest_wiki/pest_wiki_detail.less';
  export default {
    name: "pest_advice",
    data () {
      return {
        list: [
          {
            id: 2,
            mes_list: [
              {
                title: '蟑螂的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['蟑螂繁殖迅速，德国小蠊在孵化后60天即可立即繁殖，理想状态下一对德国小蠊可以繁衍出&gt;10000只后代。', '德国小蠊是唯一长时间将卵鞘携带在身上的蟑螂，一般在孵化前产下，有时卵荚挂在尾端就开始孵化。',
                      '美洲大蠊、黑胸大蠊在卵鞘成型一天内便会将其产置在合适地点，一般接近食源或是沿着墙壁、木结构表面等。'
                    ]
                  },
                  {
                    type: '取食',
                    text: ['蟑螂几乎所有东西都可能成为它的食物，包括其同类。但更偏爱发酵食物和甜食。', '在有水的条件下，可以在没有食物的情况下生存2-3个月。', '拥有最原始的咀嚼式口器。']
                  },
                  {
                    type: '活动',
                    text: ['厨房、橱柜、货运车等是德国小蠊常光顾的地方。人们习惯收集的纸箱、盒子、纸制品也是它们的藏身之处。', '大蠊喜欢潮湿、黑暗，对腐烂有机物情有独钟，所以常见于下水道、污水管、检修孔等地。', '喜欢钻缝藏洞，昼伏夜出，大多时间躲在暗处。']
                  }
                ],
                img: '2-15.jpg',
                fuget_id: '306'
              },
              {
                title: '蟑螂的危害',
                mes: [
                  {
                    type: '',
                    text: ['蟑螂携带约40种病菌，对人体健康造成极大威胁。可通过蟑螂传播的微生物超过200种，会引发哮喘、肺炎、痢疾、腹泻、肺结核、伤寒等疾病。',
                      '蟑螂边吃边拉，会产生带有异味的分泌物，使食物变味，对食物和生活环境造成污染。',
                      '蟑螂排泄物和蜕皮中含有大量过敏源，易引发过敏反应，如皮肤瘙痒、气喘等。混有蟑螂躯干和粪便的屋内灰尘常会引发过敏反应。同时，蟑螂也与儿童哮喘有关。',
                      '蟑螂有最原始的咀嚼式口器，会损坏衣物、书籍、文物等。更严重的是，它们还会咬坏电线等物品，造成事故隐患（如导致线路受潮损坏、短路事故等）。']
                  }
                ],
                img: '1-17.jpg',
                fuget_id: '307'
              },
              {
                title: '蟑螂的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['门窗等处加装纱门、纱窗，管道检修孔、排水孔上添加细目滤网。',
                    '新物品进入室内前，要仔细检查（如饮料纸箱、快递纸盒、箱包、用过的器具或家具），不用的杂物定期处理。',
                    '食物切忌敞开放置，多使用密封碗、密封条等密封食物。',
                    '尽量避免在床上、沙发上吃零食，以免食物碎屑落在隐蔽处吸引蟑螂。',
                    '保证家庭环境卫生，特别是厨房和卫生间的清洁。垃圾日产日清，不久置，不过夜；潮湿区域加强通风，保持干燥。']
                  }
                ],
                img: '3-16.jpg',
                fuget_id: '298'
              }
            ]
          },
          {
            id: 3,
            mes_list: [
              {
                title: '白蚁的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['白蚁分飞繁殖期基本为每年3～6月份。', '绝大多数白蚁首先由卵开始孵化，变为幼蚁，幼蚁经过分化，变为兵蚁、工蚁和若蚁。', '白蚁蚁后繁殖能力强，每天能生产&gt;10000枚卵，有些品种的白蚁甚至可以孤雌生殖。']
                  },
                  {
                    type: '取食',
                    text: ['木制品是白蚁主要食物，通常白蚁从木材内部开始侵蚀。', '纸张、棉麻、食品和中药材等也是白蚁的食物来源之一。', '白蚁取食由工蚁进行，工蚁将食物吞入体内，并将已经消化或半消化的食物或液体，从口吐出或从肠管末端排出，喂给不能取食的幼蚁、兵蚁、蚁王、蚁后。']
                  },
                  {
                    type: '活动',
                    text: ['水源对于白蚁的生活极关重要。', '喜欢居住于温差小的环境；当温度升高时，白蚁会向土壤深处移动，反之亦然。', '一般在隐蔽阴暗的地方活动，因其生理缺陷，大多数无眼，体壁柔软，惧光。即使在不得不与外界接触时，也会先修筑蚁道，或利用晚间进行短期露天活动。']
                  }
                ],
                img: '1-83.jpg',
                fuget_id: '319'
              },
              {
                title: '白蚁的危害',
                mes: [
                  {
                    type: '',
                    text: ['白蚁的危害十分广泛，纸张、作物、电线电缆、插座、钢筋水泥和铜铁部件等会遭到白蚁侵蚀，带来巨大的经济损失和对人民生命的严重威胁。以美国为例，每年白蚁造成的损失逾50亿美元。',
                    '白蚁可以钻过&lt;1mm的缝隙，分飞季还能轻松飞上高楼，入侵时不易被发觉，导致造成很大损失时才有发觉。白蚁善于穿墙打洞，怕光，筑巢地点隐蔽，往往在危害物内筑起四通八达的蚁道，造成大面积结构性危害。']
                  }
                ],
                img: '4-10.jpg',
                fuget_id: '321'
              },
              {
                title: '白蚁的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['清除房屋周围的枯树、树桩、树枝、碎屑、纤维素物料和落叶。',
                    '及时维修泄漏的水龙头和管道，渗水、漏水容易为白蚁创造滋生环境。',
                    '在花坛、栅栏及装潢上使用经过防蚁处理的木料。',
                    '春夏傍晚关好门窗、纱窗等，防止白蚁飞进居室，万一发现有“漏网之鱼”，尽快采取措施将其歼灭，以绝后患。',
                    '成功的白蚁综合治理方案是预防、处理和监测的结合，是一个长期的系统工程。建议定期邀请虫害控制专家进行检查和防治。']
                  }
                ],
                img: '3-75.jpg',
                fuget_id: '310'
              }
            ]
          },
          {
            id: 4,
            mes_list: [
              {
                title: '老鼠的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['每年惊蛰开始，老鼠开始进入繁衍高峰期。', '家栖鼠类生长发育快，性成熟早。幼鼠出生2－3个月即可怀孕，妊娠期一般为20天左右，分娩后可立即发情，全年大部分时间都繁殖。', '家栖鼠一般一年可怀孕5－7次，平均每胎6－12只。']
                  },
                  {
                    type: '取食',
                    text: ['褐家鼠几乎无所不食，但更倾向于含水丰富的食物。每日需水15－30ml。', '黄胸鼠属杂食动物，但更倾向于植物性食物，如蔬菜、水果、稻谷等。', '小家鼠体型小，代谢率高，因此必须不停寻找食物，昼夜活动。']
                  },
                  {
                    type: '活动',
                    text: ['小家鼠喜栖息于干燥、离食源近的场所，常在仓库货物堆、破箱、抽屉中筑巢。', '黄胸鼠喜栖息于高层隐蔽场所，如屋顶、天花板、树枝上以及杂物堆。', '褐家鼠多栖息于温暖潮湿的地方，如建筑物周围、垃圾场周围、水沟以及下水道等处。']
                  }
                ],
                img: '2-79.jpg',
                fuget_id: '332'
              },
              {
                title: '老鼠的危害',
                mes: [
                  {
                    type: '',
                    text: ['传播疾病。鼠类可以直接把疾病传播给人类或通过体外寄生虫间传播给人畜。鼠可传播高达35种以上疾病，如鼠疫、流行性出血热、班疹伤寒等。历史上被鼠类传播疾病夺走的生命据专家估计超过历史上所有战争死亡人数的总和。',
                    '一旦他们进入了您的住宅中，还可能带来很多寄生虫，如跳蚤、螨虫和蜱虫等。',
                    '老鼠是啮齿类动物，容易对线路、通讯、家具甚至房屋结构造成破坏，引发事故。',
                    '粮食安全问题。世界由于鼠害造成粮食损失最高可达到收获量的15％－20％，够1.5亿人全年的口粮。']
                  }
                ],
                img: '1-82.jpg',
                fuget_id: '333'
              },
              {
                title: '老鼠的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['封堵鼠道：门窗等处注意严丝合缝，门与门框、窗与窗棱避免留较大空隙；通风口、下水道等处加装细目滤网；各种管道或电缆进出建筑的孔洞做好封堵', '食源清理：剩饭剩菜需密封保管，将宠物食品存放在有盖的密封容器内并远离地面存放；厨余垃圾、可供鼠食用的遗弃食品及积水及时清理', '注重卫生清洁：定期对屋内平时清扫的卫生死角进行检查和清理，及时清理杂物；排水沟的疏通与清理；花园内不要有垃圾。如果您的花园内有堆肥，不要将有机食物残渣放到堆肥内，否则会吸引鼠类']
                  }
                ],
                img: '3-74.jpg',
                fuget_id: '324'
              }
            ]
          },
          {
            id: 5,
            mes_list: [
              {
                title: '蚂蚁的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['当一窝蚂蚁达到一定数量时，蚁后会提前繁殖出雄性繁殖蚁和雌性繁殖蚁，时机成熟后繁殖蚁飞出巢外交配后开始繁殖后代成为一个新的家族。', '处女雌蚁（未来蚁后）与雄蚁交配并受精一次，即可终生产卵。', '在适宜条件下，雌蚁每天可产下500枚以上的卵。']
                  },
                  {
                    type: '取食',
                    text: ['蚂蚁属杂食性昆虫，绝大部分蚂蚁都喜食甜食。', '蚂蚁幼虫和蚁后均无取食能力，需工蚁喂食。', '当工蚁取食后，会把食物储藏在嗉囊内，带回巢穴中喂给其他蚂蚁。']
                  },
                  {
                    type: '活动',
                    text: ['家庭蚂蚁一般在墙壁缝隙、瓷砖缝、地板下、家具缝隙中筑巢。小黄家蚁还喜欢选择供水供暖管道的缝隙筑巢。', '蚂蚁昼夜都有活动，而夜晚的活动多于白天，一般午夜12点到凌晨4点是活动高峰。']
                  }
                ],
                img: '2-81.jpg',
                fuget_id: '348'
              },
              {
                title: '蚂蚁的危害',
                mes: [
                  {
                    type: '',
                    text: ['骚扰叮咬：蚂蚁侵入室内会影响人们的正常生活和身心健康。小黄家蚁，红火蚁等还会叮咬人，尤其是小孩，易造成化脓感染。', '传播疾病：蚂蚁在到处爬行过程中，易接触各种传染性病原体，并能机械性地将各种细菌、病毒等病原体带到人类易接触的场所和食物表面，既污染食物，又传播疾病。', '损坏设施：蚂蚁有啃噬的习性，会破坏电子设施，各类管线和木料，造成损失。']
                  }
                ],
                img: '1-84.jpg',
                fuget_id: '349'
              },
              {
                title: '蚂蚁的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['蚂蚁会被厨房的油脂和食物所吸引，需要重点清洁炉灶、冰箱、微波炉、洗碗机和水槽周围和下方，定期清洗碗筷，擦拭地板。', '将食物集中存放在金属、玻璃或硬塑料的容器中，并进行密封。', '室内定期进行真空吸尘并擦拭地板，及时清洁食物碎屑；垃圾要日产日清。', '定期清理排水沟、排水管和水槽，去除草屑、落叶和堆积的木头。']
                  }
                ],
                img: '3-76.jpg',
                fuget_id: '339'
              }
            ]
          },
          {
            id: 6,
            mes_list: [
              {
                title: '跳蚤的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['跳蚤具有4个生命周期：卵，幼虫，蛹和成虫。', '雌虫一生可以产卵5000枚或者更多，通常在宿主身上产卵，具备非凡的繁殖能力。', '成虫必须嗜血才能进行繁殖。']
                  },
                  {
                    type: '取食',
                    text: ['当跳蚤咬住皮肤吸血时，会排出黑黑的粒便，常被误以为是跳蚤卵。这些“黑砂子”，碰到水就溶解变成血色。', '跳蚤的成虫可以12个月不吃任何东西，一有机会便经由吸血来获得养分。']
                  },
                  {
                    type: '活动',
                    text: ['跳蚤无特定之宿主，在各种有毛的动物身上均可寄生。', '跳蚤即可能在动物的被毛下产卵，也会在布料、地毯上产卵。虫卵有卵壳保护，可以存活较长一段时间，待孵化后再伺机回到动物身上寄生。', '户外草地上，也是跳蚤产卵的温床，狗猫在室外活动很有可能回来将跳蚤携带回室内。']
                  }
                ],
                img: '2-82.jpg',
                fuget_id: '362'
              },
              {
                title: '跳蚤的危害',
                mes: [
                  {
                    type: '',
                    text: ['一旦进入室内，跳蚤就会繁殖并以人或动物的血液为食，被叮咬后会产生瘙痒，产生过敏反应。', '跳蚤在吸食人或动物宿主的血液时或通过受污染的粪便颗粒传播疾病，一些较常见的蚤传疾病包括：鼠疫、蚤传斑疹伤寒、巴氏杆菌病(猫抓病)。']
                  }
                ],
                img: '1-85.jpg',
                fuget_id: '364'
              },
              {
                title: '跳蚤的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['家中如有宠物，应定期给宠物修剪毛发、清洁和体内外驱虫；从室外回来后应进行检查和清洁。', '做好清洁工作，定期吸尘，且要全面彻底，吸尘后要将袋从吸尘器中取出，放入密封塑料袋中并丢到户外。', '高温清洁被单、床褥、地毯等物品或在阳光下曝晒。', '勿在屋内屋外、地下车库等地堆积杂物。在防治跳蚤的同时，也要留意老鼠、流浪猫狗的进入，它们身上可能携带了跳蚤。']
                  }
                ],
                img: 'flea.jpg',
                fuget_id: '353'
              }
            ]
          },
          {
            id: 7,
            mes_list: [
              {
                title: '苍蝇的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['苍蝇具有强大的繁殖能力，每次产卵120-150粒。', '在温暖潮湿的环境下，苍蝇能在6-10天内完成从虫卵到带翼成虫的生命周期，在一个月之内可以产下两代或两代以上的苍蝇。']
                  },
                  {
                    type: '取食',
                    text: ['苍蝇以舔吸式口器吸食液态的食物，如果食物是固态的，苍蝇会先吐出嗉囊液溶解它再取食，这种饮食行为会导致在苍蝇觅食的表面出现浅色的斑点。', '苍蝇以人类和动物的粪便、尸体及生活垃圾为食，还有“边吃边吐边拉”的习惯，容易污染食物和餐具。']
                  },
                  {
                    type: '活动',
                    text: ['苍蝇白天活动频繁，具有明显的趋光性。夜间则趋向静止栖息。', '苍蝇的活动受温度影响很大。它在4～7℃时仅能爬行，10～15℃ 时可以飞翔，20℃ 以上才能摄食、交配、产卵，30～35℃ 时尤其活跃。', '苍蝇善于飞翔。飞行速度可达每小时6-8km，最高每昼夜飞行8-18km。']
                  }
                ],
                img: '01-5.jpg',
                fuget_id: '376'
              },
              {
                title: '苍蝇的危害',
                mes: [
                  {
                    type: '',
                    text: ['苍蝇喜欢在人或畜的粪尿、痰、呕吐物以及尸体等处爬行觅食，极容易附着病原体。又因其常在人体、食物、餐饮具上停留，停落时有搓足和刷身的习性，附着在它身上的病原体很快就污染食物和餐饮具。', '一只苍蝇的体表最多可沾有多达5亿个细菌，可以传播各种疾病，如霍乱、伤寒、痢疾、肝炎、脊髓灰质炎病、甲肝乙肝等。', '四处乱飞的苍蝇也会给人和动物带来滋扰。']
                  }
                ],
                img: '03-6.jpg',
                fuget_id: '378'
              },
              {
                title: '苍蝇的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['用尺寸合适的防蝇纱网覆盖窗户，特别是厨房以及废物存放区域的窗户。', '食物及时封存或用盖子盖好，避免苍蝇接触造成污染。', '及时清理垃圾，垃圾桶尽量避免敞开式的；定期对房间卫生死角进行检查和清理。', '注意水源存储，用大小合适的盖子盖上所有储水容器；不要留有死水，如水罐或花盆中的水，这些会给苍蝇提供产卵场所。', '保持下水道清洁，确保其中没有残渣堆积，以减少苍蝇的繁殖点。']
                  }
                ],
                img: 'notitle-2-1.jpg',
                fuget_id: '367'
              }
            ]
          },
          {
            id: 8,
            mes_list: [
              {
                title: '',
                mes: [
                  {
                    type: '繁殖',
                    text: ['蚊虫属于完全变态昆虫，要经历卵、幼虫、蛹、成虫四个成长阶段，完成一个生命周期约需14天，而卵、幼虫、蛹在水中发育则需11-12天。', '按蚊雌蚊每次可产50-200粒卵，卵为船型，有浮囊，一个个独立浮在水面上；库蚊卵集结成救生艇状，一次可高达300粒；伊蚊卵可适应干燥环境。']
                  },
                  {
                    type: '取食',
                    text: ['蚊子吸血时，会反复的穿刺皮肤，藉这个动作来寻找最适合的穿刺位置（以微血管密度决定）。接着，将口针刺入皮肤并注射含有抗凝血化合物的唾液，有时唾液含有病原体并可能感染寄主。', '雌蚊吸血主要是为了交配后产卵（并非靠吸食血液维生），所以它们的口器特化为细长的喙，以便刺穿动物的皮肤。']
                  },
                  {
                    type: '活动',
                    text: ['蚊子幼虫又称孑孓，通常生活在池沼、水沟或积水的器皿等处。', '雌蚊借由特殊的感应器来寻找它们的猎物。雌蚊对二氧化碳、热及汗水非常敏感，所以它们能在一定的距离内寻找恒温动物的哺乳类和鸟叮咬。']
                  }
                ],
                img: '2_wenzi.jpg',
                fuget_id: '407'
              },
              {
                title: '蚊子的危害',
                mes: [
                  {
                    type: '',
                    text: ['疟原虫造成的疟疾是全球人类主要的死因之一，尤其是五岁以下的孩童，更容易受到疟疾的感染而死亡。疟疾每年约造成3百万人死亡；蚊子还能够传播多种疾病，如丝虫病、疟疾、登革热、基孔肯雅病、乙型脑炎等。', '蚊虫叮咬过程中会将唾液注入宿主体内，这些唾液中含有抗原，会导致部分人产生严重的过敏反应，可能会很快发生，也可能是迟发性的。', '蚊虫翅膀快速振动发出的独特嗡嗡声让人厌烦，导致人睡眠不足，休息不够甚至神经紧张。']
                  }
                ],
                img: '1-86.jpg',
                fuget_id: '408'
              },
              {
                title: '蚊子的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['安装纱窗、蚊帐等，物理阻隔蚊虫。', '每周清理房屋周围的下水道以防止堵塞；盖住所有储水容器，以防止蚊虫产卵；清除积水，清除不用的轮胎、空罐头和空瓶子，以防它们成为蚊虫的繁殖地；及时给花瓶和储水容器换水。', '不穿深色的衣服或使用气味过于强烈的东西，比如香水和除臭剂；减少裸露的皮肤，穿好长袖、长裤和鞋子，戴好帽子。', '夏季避开积水区、植被茂密的有区域，在户外可使用含避蚊胺、派卡瑞丁、驱蚊脂、柠檬桉等成分的驱蚊产品。', '美国儿科学会（AAP）仅推荐含避蚊胺、派卡瑞丁成分的驱蚊产品用于儿童驱蚊，2个月以下的婴儿这两种成分也应禁用；3岁以下儿童禁用含柠檬桉的产品。']
                  }
                ],
                img: '3-77.jpg',
                fuget_id: '400'
              }
            ]
          },
          {
            id: 9,
            mes_list: [
              {
                title: '臭虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['臭虫发育为渐变态，生活史有卵、若虫和成虫3期。若虫和成虫都嗜吸人血。', '臭虫拥有储精囊，雌性臭虫一生只需交配一次便可终生不用再交配便具有繁殖能力。期间雌性臭虫可产卵200-400枚，数量视食物供应而定，也受温度影响。虫卵约于十天后孵化。', '在温暖地区适宜条件下臭虫每年可繁殖六、七代，成虫寿命可达9～18个月。']
                  },
                  {
                    type: '取食',
                    text: ['臭虫是一种强制性吸血昆虫。其寻找宿主的办法主要是通过寻找宿主排出的二氧化碳和热量。', '臭虫的口器刺穿宿主的皮肤时，会在皮肤上留下两个孔洞；其口器有两条空心的进食管，一条用来向宿主注射含有抗凝血剂和麻醉剂的唾液，另一条用来从宿主身上吸取血液。', '臭虫可以在没有进食的情况下仍可生存长达一年的时间；平时每隔5-10天进食一次。']
                  },
                  {
                    type: '活动',
                    text: ['臭虫怕光，多在夜间活动。臭虫活动很敏捷而机警，可以在宿主不留意下吸取宿主的血液，在吸血时，如人体稍有移动，即停止吸血，爬走而隐藏，臭虫每分钟能爬行1-1.25m。', '臭虫喜群居，并可随衣物、行李携带传播。主要栖息在床架、床头板、墙壁、桌椅、书架、被子褥、草垫、床席等的缝隙和糊墙纸的后面。栖息处所带有许多褐色的粪迹。']
                  }
                ],
                img: '1-88.jpg',
                fuget_id: '420'
              },
              {
                title: '臭虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['臭虫叮咬、吸血会引发瘙痒、失眠、神经衰弱，严重的还会导致贫血症状。', '臭虫有一对臭腺，能分泌一种异常臭味，令人厌恶。', '臭虫叮咬会引起灼烧感和瘙痒，被咬处会起红疹，严重时咬痕会连成一串。']
                  }
                ],
                img: '3-79.jpg',
                fuget_id: '422'
              },
              {
                title: '臭虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['酒店是臭虫的高发区，在外出行入住时，应先对房间进行检查。快速检查方法：将床单拉起，检查床垫周围的缝隙和床头板等处空隙，看有没有血迹或者小黑点。', '避免将行李箱或者背包直接放在地上或备用床铺上；将背包放在桌子上或行李架上，或将行李箱用塑料包裹，预防臭虫进入。', '旅行回家后尽快高温清洗和烘干衣物等行李（水温高于60度），能帮助您清除可能带回的臭虫。', '使用吸尘器可以一定程度减少臭虫的数量；吸尘后，应及时清空吸尘器，以防将臭虫卵带到其他房间。']
                  }
                ],
                img: '2-84.jpg',
                fuget_id: '412'
              }
            ]
          },
          {
            id: 10,
            mes_list: [
              {
                title: '寄螨的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['蜱虫产前均需要饮血。雄性蜱虫在交配后即会死亡。', '雌性硬蜱和软蜱繁殖行为略微不同：雌性硬蜱产卵为一次性，一次可产2500-3000枚，产后即死亡。雌性软蜱则可以分多次产卵，持续数年。', '成年革螨可每天产卵十余枚，持续约六周时间，直至死亡。']
                  },
                  {
                    type: '取食',
                    text: ['硬蜱多在白天叮咬宿主采食血液，且吸血时间较长，可长达数天；软蜱多在夜间吸血，吸血时间短，一般数分钟到一小时。', '蜱的吸血量很大，各发育期饱血后可胀大几倍至几十倍。', '寄生性革螨以刺吸宿主的血液和组织液为食。巢栖型革螨的吸血量较大，耐饥力较强；毛栖型革螨吸血量较小，耐饥力差。']
                  },
                  {
                    type: '活动',
                    text: ['蜱虫有敏锐的嗅觉，可以通过汗味、二氧化碳寻觅宿主。野生动物、家畜、宠物、鸟类、人都可能成为其寄生对象。', '蜱虫一般喜欢在皮肤较薄，不易被搔动的部位为害，如颈部、耳后、腋窝、腹股沟等处。', '革螨多寄生于宿主的体表，少数可能会寄生于鼻腔、呼吸道、外耳道等处。鸡、鸟是其最常见的宿主。']
                  }
                ],
                img: '4.jpg',
                fuget_id: '436'
              },
              {
                title: '寄螨的危害',
                mes: [
                  {
                    type: '',
                    text: ['蜱虫叮咬宿主，吸血会造成宿主血液损失，导致皮肤出现水肿、伤口发炎、溃疡等症状。', '蜱虫的唾液含有麻痹神经毒素，会导致肌肉麻痹，严重时会导致瘫痪。此外蜱还可能传播一些罕见疾病，如莱姆病、森林脑炎、出血热、红肉过敏症等。', '革螨不仅会引发皮炎，还会通过刺螫传播病毒，引起森林脑炎、Q热、斑疹伤寒等。虽然尘螨也会引起过敏反应，但并不会像革螨一样引起明显咬伤。']
                  }
                ],
                img: '5-4.jpg',
                fuget_id: '437'
              },
              {
                title: '寄螨的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['在户外活动时，尤其是草地、丛林区域，尽量着长袖长裤。在暴露的皮肤上喷涂驱蚊液，且尽量避免在野外长时间坐卧。', '户外回来对宠物和自身进行检查，尤其是毛发处；宠物定期做清洁和除虫。', '注意清理修剪家中的草坪、植物等。对于有花园、草坪的家庭可定期请专业人员上门做预防处理。', '保持环境卫生，常吸尘，定期高温（&gt;0摄氏度）清洗床品衣物，或在阳光下曝晒。', '如确定受到寄螨攻击，应尽快就诊，并请专业虫害防治人员上门治理。']
                  }
                ],
                img: '6-1-1024x575.jpg',
                fuget_id: '427'
              }
            ]
          },
          {
            id: 11,
            mes_list: [
              {
                title: '衣鱼的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['衣鱼繁殖能力较强，交配在夜晚进行，雄虫会产下一个用薄纱包住的精胞，雌虫摄取精胞并在体内完成受精并在隐蔽的缝隙产卵。', '衣鱼从幼虫到成虫约需4～6个月，衣鱼的发育为表变态，幼虫到成虫要蜕皮8次，成虫期也仍会脱皮，寿命可长达2～8年。']
                  },
                  {
                    type: '取食',
                    text: ['衣鱼偏爱充满淀粉质或多糖的物品，如胶水、浆糊、糖、毛发等。', '但它们其实食性广泛，对棉花、亚麻、丝等也不抗拒，甚至连其他昆虫的尸体、自己褪的皮也吃的甘之如饴。', '耐饥饿能力强，可以挨饿数月身体机能也不受任何伤害。']
                  },
                  {
                    type: '活动',
                    text: ['衣鱼可随器物搬迁而传播，当书柜、书架、书箱搬运时，其中成虫、幼虫、卵可随之传播到异地。', '衣鱼活动能力很强，可以快速敏捷移动，防治起来十分困难。', '当遇到蠼螋、蜘蛛、壁虎等天敌时，衣鱼会用尾梢吸引天敌注意力，当尾巴被天敌抓住时，其分节的尾巴即会断掉，主身便可乘机逃脱。']
                  }
                ],
                img: '2-33.jpg',
                fuget_id: '447'
              },
              {
                title: '衣鱼的危害',
                mes: [
                  {
                    type: '',
                    text: ['衣鱼会啃食书籍、衣物、墙纸装潢等物品，造成损失破坏。', '虽然不咬人，但衣鱼可能会引发一些人群的过敏。', '家中如果有衣鱼滋生，还可能因此吸引其他害虫为害。']
                  }
                ],
                img: '3-38.jpg',
                fuget_id: '449'
              },
              {
                title: '衣鱼的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['定期检查家中阴暗潮湿区域，尽量保持室内通风干燥，尤其是书房。', '做好室内清洁，尤其是踢脚线、墙角等一些缝隙、犄角旮旯。', '定期整理书堆、书籍，及时清理丢弃家中的纸箱、废纸等杂物。']
                  }
                ],
                img: '4-2.jpg',
                fuget_id: '440'
              }
            ]
          },
          {
            id: 12,
            mes_list: [
              {
                title: '厨卫飞虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['大部分厨卫飞虫繁殖能力惊人：一只雌性果蝇能够产下大约500个卵，雌性蛾蚋平均可产卵约241粒。', '繁殖周期短：果蝇卵产出后24-30小时内即可孵化；蛾蚋约为2日，羽化后3-4日即可产卵。']
                  },
                  {
                    type: '取食',
                    text: ['大部分厨卫飞虫喜食腐烂的有机质，管道内的污垢、厨余垃圾、植物产生的真菌、枝叶等都可能成为它们的食物。', '如果蝇，喜欢以腐烂的水果或植物体为食，有些也会取食真菌，树液或花粉等；蚤蝇幼虫主要以土壤中的真菌和有机物为食。']
                  },
                  {
                    type: '活动',
                    text: ['大部分厨卫飞虫与厨房、卫生间的排水系统息息相关。如蚤蝇，喜欢在管道深处繁殖；蛾蚋，通常由排水缓慢或堵塞引起。', '阴暗的、藏污纳垢的管道深处或富含腐殖质场所是它们的滋生地。', '此类飞虫大都具有趋光性，由于体型微小，一些家庭即使装了纱窗可能也无法阻挡它们进入室内。']
                  }
                ],
                img: '2-39.jpg',
                fuget_id: '461'
              },
              {
                title: '厨卫飞虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['厨卫飞虫通常成群结队出现，其滋生会对人们的生活带来严重的滋扰。', '一些厨卫飞虫如蕈蚊的幼虫会取食土壤中的真菌和有机物，可能导致植物生病枯萎。', '多数厨卫飞虫可能会污染食物，破坏食物的口感；并且易接触和携带环境中的细菌，或传播疾病。']
                  }
                ],
                img: '3-39-1024x575.jpg',
                fuget_id: '462'
              },
              {
                title: '厨卫飞虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['加强厨卫区域的清洁，尤其要注意一些缝隙、暗角；加强厨卫区域通风，保持干燥。', '厨房食物密封保存；厨余垃圾桶选择有盖版；厨余垃圾及时处理，不过夜。', '纱窗尽可能选择细目纱窗，以免孔洞过大无法阻拦这些小飞虫从外部进入。', '排水口添加细目滤网地漏使用防臭地漏，定期用消毒片、消毒液清洁管道，避免毛发、食物堵塞，在管道里腐烂，引起滋生。']
                  }
                ],
                img: '4-4-1024x575.jpg',
                fuget_id: '454'
              }
            ]
          },
          {
            id: 13,
            mes_list: [
              {
                title: '织物害虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['织物害虫都是完全变态行昆虫，生活史包括「卵—幼虫—蛹—成虫」四个阶段。', '衣蛾成虫不进食仅负责繁殖。雌衣蛾一次可产40-200枚，这些卵一个个独立分开，约在10-15天孵化为幼虫。']
                  },
                  {
                    type: '取食',
                    text: ['织物害虫都爱天然蛋白（角蛋白），通常是幼虫取食为害。皮革、羊毛、丝绸等都是其喜食的对象。', '黑皮蠹、花斑皮蠹等食性复杂，除了以织物为食，也会吃粮食谷物。', '织物害虫尤其是其幼虫，抗饥饿能力都很强，花斑皮蠹为例，食物缺乏时，可以忍饥数月。']
                  },
                  {
                    type: '活动',
                    text: ['衣蛾幼虫惧光，通常孳生在阴暗处；成虫属夜行性，在室内灯光下可看到它们飞行或停留在墙面上。', '织物害虫不耐低温，皮蠹一般10摄氏度以下无法正常繁殖和取食。']
                  }
                ],
                img: '2-44-1024x574.jpg',
                fuget_id: '475'
              },
              {
                title: '织物害虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['家中感染衣蛾等织物害虫会很难除尽，衣蛾幼虫会取食羊毛、毛皮、地毯、毛毯、化纤羊毛、棉混织料，对衣物家纺等织物造成伤害。', '花斑皮蠹食性复杂，幼虫从谷物到宠物食品和糖果都可能带来破坏。家中婴儿如果不小心摄入幼虫或幼虫的蜕皮可引起肠道或肠道刺激。', '潜在的昂贵代价。一些珍贵的面料、收藏品、乐器等如果不做好防护，都容易受到织物害虫的破坏。']
                  }
                ],
                img: '3-40.jpg',
                fuget_id: '476'
              },
              {
                title: '织物害虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['在衣物收回衣柜之前，将衣物进行彻底的清洁，尤其是衣物折叠处。谨记不要将沾有污渍或留有汗味的衣服放进衣柜，汗味会更加吸引织物害虫。', '经常将衣物或地毯等高温清洗或拿到阳光下曝晒。', '保持衣柜环境干燥清洁，室内多通风，多开窗让阳光照进屋里。', '用吸尘器清理房间时，确保清理到家具下面、地毯边缘、踢脚线附近的地方。清理完成后，及时清理倾倒吸尘器中的垃圾。', '食物密封保存。反季或许久不穿的衣物用真空袋保存。']
                  }
                ],
                img: '4-5-1024x575.jpg',
                fuget_id: '467'
              }
            ]
          },
          {
            id: 14,
            mes_list: [
              {
                title: '蛀木害虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['许多蛀木害虫喜欢把卵产在木材上。例如粉蠹，天牛、窃蠹等，其成虫会在木材表面或内部产卵，卵孵化成为幼虫后，开始钻入木材内部。', '蛀木害虫产卵多产于被害物的缝隙处，分散产或集中成堆。繁殖数量不容小觑，一只雌性窃蠹一次可产50-75枚卵。']
                  },
                  {
                    type: '取食',
                    text: ['大部分蛀木害虫的幼虫以木材为食，天牛、窃蠹、粉蠹、小蠹等，其幼虫都会往木材深处钻入，一路吃到底。', '蛀木害虫及其幼虫们通常有咀嚼式的口器。', '不同蛀木害虫对木材质地有不同的偏好。窃蠹喜食潮湿且部分腐坏的木头；黑尾拟天牛、粉蠹幼虫都喜欢潮湿的枯木；天牛幼虫则可以蛀食干燥木材。']
                  },
                  {
                    type: '活动',
                    text: ['蛀木害虫通常生命周期较长，隔年羽化。', '很多蛀木害虫成虫并不啃食木材，例如粉蠹，其成虫的使命就是交配繁殖']
                  }
                ],
                img: '2-1024x574.jpeg',
                fuget_id: '491'
              },
              {
                title: '蛀木害虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['理所当然，蛀木害虫会对房屋木质结构和木家具等造成破坏。许多会在木材表面留下难看的孔洞。如果您家有名贵的木质地板、高档家具，或种植了名贵的树木花草，也可能以为它们付出昂贵的代价。', '竹蠹等蛀木害虫还可能危害稻谷、薯干等农作物、粮食。', '一些蛀木害虫，如黑尾拟天牛会分泌毒液，人被咬后，会过敏、起水泡。']
                  }
                ],
                img: '3-45.jpg',
                fuget_id: '493'
              },
              {
                title: '蛀木害虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['定期对室外绿化进行打理，及时清理枯枝杂草，保持树木健康。', '安装门窗纱窗，防止蛀木害虫进入室内。', '保持室内通风干燥，尽量不用湿拖把湿抹布清洁木材，或清洁完后尽快擦干。', '购置木材时应进行详细检验；木材使用前应给予干燥、表面打光等处理。', '装修前对即将入室的木材进行药液预防处理，有效预防虫卵滋生。']
                  }
                ],
                img: '4-6.jpg',
                fuget_id: '481'
              }
            ]
          },
          {
            id: 15,
            mes_list: [
              {
                title: '叮蛰害虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['大多数叮蛰害虫为社会性昆虫，有明确的分工，蜂王负责产卵，每日可产上百枚卵；雄峰负责和蜂王交配，且交配完后便立即死亡。', '寄生蜂则比较独来独往，雌性寄生蜂交配后会积极寻找宿主，发现寄主后，将卵产于体内。']
                  },
                  {
                    type: '取食',
                    text: ['寄生蜂幼虫孵化后会取食寄主的营养，和寄主共生一段时间后才使寄主死亡。', '大部分叮蛰害虫均有采蜜行为，糖分与它们的生存和繁殖都息息相关，但其中也不乏肉食性的。譬如胡蜂是杂食性的，它还会捕杀蜜蜂。']
                  },
                  {
                    type: '活动',
                    text: ['社会分工。大多数叮蛰害虫有明确的等级职能划分，且种群大多数为工蜂。', '其腺体会释放一种微量化学信息物质，被称为信息素，依靠空气或个体间的接触进行传播，用于相互间沟通。', '雄性数量少，且不具攻击属性，其唯一的使命就是与蜂王交配。']
                  }
                ],
                img: '2-57.jpg',
                fuget_id: '507'
              },
              {
                title: '叮蛰害虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['在户外尽量着长袖长裤，尽量不用甜味较重、气味较浓的香水，这些特殊味道可能会吸引叮蛰害虫。', '窗户装好纱窗，及时清理家中垃圾，避免吸引黄蜂觅食。', '若被叮蛰害虫蛰伤，应将蜂针拔出，用肥皂水清洁伤口，并尽快就医。', '定期检查房屋周围是否有叮蛰害虫筑巢。如果黄蜂入侵室内，最好不要尝试强制驱除，以免引发攻击。及时请专业人员上门处理。']
                  }
                ],
                img: '4-7.jpg',
                fuget_id: '498'
              },
              {
                title: '叮蛰害虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['在户外尽量着长袖长裤，尽量不用甜味较重、气味较浓的香水，这些特殊味道可能会吸引叮蛰害虫。', '窗户装好纱窗，及时清理家中垃圾，避免吸引黄蜂觅食。', '若被叮蛰害虫蛰伤，应将蜂针拔出，用肥皂水清洁伤口，并尽快就医。', '定期检查房屋周围是否有叮蛰害虫筑巢。如果黄蜂入侵室内，最好不要尝试强制驱除，以免引发攻击。及时请专业人员上门处理。']
                  }
                ],
                img: '4-7.jpg',
                fuget_id: '498'
              }
            ]
          },
          {
            id: 16,
            mes_list: [
              {
                title: '潮湿害虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['潮湿害虫的繁殖能力很强，如书虱，一只雌性书虱可产~100枚卵。', '繁殖周期短，譬如跳虫一年至少繁殖四代，往往集体出现。', '通常把卵产在潮湿木头表面、书架书柜、踢脚线处、门窗框等处。']
                  },
                  {
                    type: '取食',
                    text: ['大多潮湿害虫均以真菌、腐烂物质为食物。', '部分食性较复杂，也会取食孢子、发芽种子、粮食等。']
                  },
                  {
                    type: '活动',
                    text: ['大都喜暗畏光，聚集在潮湿阴暗角落。但书虱喜欢高温，所以往往雨后温度升高时会大量出现。', '不同种类的潮湿害虫还可能结伴而生，如跳虫、薪甲。', '在遇到危险时，大多数会假死以自我保护。']
                  }
                ],
                img: '2-61.jpg',
                fuget_id: '519'
              },
              {
                title: '潮湿害虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['通常成群结队出现，其滋生会对人们的生活带来严重的滋扰。', '会取食真菌、有机物，可能导致植物生病或污染食物。', '因与真菌相伴为生，如大量爆发，可能会闻到一股霉味，影响呼吸健康。']
                  }
                ],
                img: '3-57.jpg',
                fuget_id: '522'
              },
              {
                title: '潮湿害虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['保持室内通风干燥，多让阳光照入室内。', '如曾遇到进水、水管破裂，应及时检修，并对进水区域进行风干处理。', '浴室使用完后应开排风扇、窗户等进行通风，勿使浴室及邻近的门窗框长期处于湿润的空气中。', '定期检查通风管道，对凝结水气、污垢进行擦拭；保持下水道清洁干净。', '保持室内整洁，及时清理掉霉变食物。', '定期对外围绿化进行预防性广谱除虫。']
                  }
                ],
                img: '4-8.jpg',
                fuget_id: '511'
              }
            ]
          },
          {
            id: 17,
            mes_list: [
              {
                title: '仓储害虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['仓储害虫均属于完全变态行昆虫，生活史包括「卵—幼虫—蛹—成虫」四个阶段。', '繁殖速度快。如锯谷盗，一年可生2-5代，每次产卵可达70-300多粒。印度谷螟一年可生8代，一只雌蛾最多可产卵300多枚。']
                  },
                  {
                    type: '取食',
                    text: ['不同种类的仓储害虫食性不同，譬如烟草甲会危害谷物豆类，但更喜欢烟叶、雪茄等制品；锯谷盗则喜食杂粮谷物；豆象偏爱豆类；米象偏爱大米。', '许多仓储害虫会直接把卵产在谷物或半加工的食品里（面粉、麸皮等），幼虫以此为食直到蛹期。']
                  },
                  {
                    type: '活动',
                    text: ['仓储害虫大都耐寒能力弱，喜欢温暖湿润的环境。例如米象，气温低于15摄氏度，成虫便会冬眠。', '蛾类幼虫通常飞到一个远离食物源的隐藏的地方化蛹，成虫后交配并将卵存放在适合的食品中。']
                  }
                ],
                img: '3-64.jpg',
                fuget_id: '537'
              },
              {
                title: '仓储害虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['仓储害虫的幼虫和成虫，有的会直接啃食粮食，对粮食储物造成破坏。', '仓储害虫生命周期的很长一段时间都在粮食储物中，会直接在粮食中排泄、蜕皮、死亡，会对粮食储物造成污染，引发粮食发霉变质。', '赤拟谷盗有臭腺分泌臭液，使面粉发生霉腥味，其分泌物还含有致癌物苯醌。', '潜在的不菲损失：像一些比较昂贵的药材、烟草，或是比较大型的仓库，如果不做好预防被仓储害虫侵害，会造成严重的经济损失。']
                  }
                ],
                img: '4-9.jpg',
                fuget_id: '538'
              },
              {
                title: '仓储害虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['家庭中，大米、面粉等粮食以及药材、烟草等物品买来时可筛选一下，之后统一用密封容器保存，低湿度和通气量可降低其活跃度和生存能力并抑制真菌生长。', '粮食物品存放在干燥的区域，勿存放于水槽下水管之类潮湿阴暗的地方。', '窗户装细目纱窗，门窗尽量不要长期敞开，尤其是夜晚开灯的时候，容易吸引蛾类飞入室内为害。', '如果在粮食储物中发现有仓储害虫，及时将被污染物丢弃，如果问题比较严重可选择专业服务进行治理。']
                  }
                ],
                img: '5.jpg',
                fuget_id: '528'
              }
            ]
          },
          {
            id: 18,
            mes_list: [
              {
                title: '多足害虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['蚰蜒在春天时产卵。一只雌性蚰蜒平均产下~60枚卵，最多可产~150枚。', '蜈蚣为卵生，雌蜈蚣一次排卵达2～3小时，每次产卵30～60枚。孵化期间雌蜈蚣不吃不喝，直到孵化出幼蜈蚣，然后长大至成虫。', '雌性马陆会孤雌繁殖，繁殖高峰在5月至9月，每头可产卵~300枚。', '潮虫、鼠妇1年繁殖1次，雌体会卵产在胸部腹面的“卵兜”内，每只产卵~30枚。']
                  },
                  {
                    type: '取食',
                    text: ['潮虫、鼠妇、马陆是大自然的分解者，以腐坏的植物、有机质为食。有时也会吃物的幼芽，根、茎和果实。', '蚰蜒、蜈蚣为掠食性动物，以捕捉小昆虫为食，如蚊蛾、蜘蛛、蟑螂、蚂蚁等。']
                  },
                  {
                    type: '活动',
                    text: ['大都喜暗畏光，聚集在潮湿阴暗角落。常出现于花盆下、水沟中和踢脚线处。', '昼伏夜出，白天多潜伏在砖石缝隙、墙脚边和成堆的树叶、杂草等阴暗角落里，夜间出来活动。', '一般在干旱或干旱期结束第一场雨后，它们便冒出地表，变得活跃。']
                  }
                ],
                img: '2-34.jpg',
                fuget_id: '554'
              },
              {
                title: '多足害虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['多足害虫外形恐怖可能是其最为直观的一个“过错”，它们的入侵会给人们的生活带来滋扰。', '多以腐殖质为食，对于植物的幼根、嫩茎、嫩叶危害极大。', '对人没有致命的威胁，但偶发的直接接触或叮咬可能会感染其毒液，产生疼痛和过敏。']
                  }
                ],
                img: '3-32.jpg',
                fuget_id: '556'
              },
              {
                title: '多足害虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['保持室内通风干燥，多让阳光照入室内。', '如曾遇到进水、水管破裂，应及时检修，并对进水区域进行风干处理。', '浴室使用完后应开排风扇、窗户等进行通风，勿使浴室及邻近的门窗框长期处于湿润的空气中。', '定期对外围绿化进行预防性广谱除虫，对房屋周围边界区域，如踢脚线、门窗、走廊进行边界预防处理，设置化学防护带。']
                  }
                ],
                img: '4-1024x575.jpeg',
                fuget_id: '547'
              }
            ]
          },
          {
            id: 20,
            mes_list: [
              {
                title: '花园害虫的生活习性',
                mes: [
                  {
                    type: '繁殖',
                    text: ['繁殖方式多样，如蛞蝓雌雄同体，异体受精，亦可同体受精繁殖，5-7月产卵；蜘蛛不是昆虫，但也卵生，会把卵产在丝织的卵袋里，一次可产数十-上百枚卵。', '大都将卵产在疏松的腐殖土中，很多为不完全变态发育，如蟋蟀、蝼蛄、蝽等。']
                  },
                  {
                    type: '取食',
                    text: ['大多以腐坏的植物、有机质为食。有些则会吃植物的幼芽，根、茎叶和果实。少部分为肉食性，如隐翅虫、蜘蛛。']
                  },
                  {
                    type: '活动',
                    text: ['很多成虫有趋光性，会被灯光吸引进入室内。', '通常聚集在潮湿阴暗角落。常出现于土壤、花盆下、水沟中、浴室、踢脚线处等区域。', '大都有昼伏夜出的习惯，白天潜藏在隐蔽处或土壤中。']
                  }
                ],
                img: '2-23.jpg',
                fuget_id: '571'
              },
              {
                title: '花园害虫的危害',
                mes: [
                  {
                    type: '',
                    text: ['花园害虫主要在外围为害，有些会直接取食各种蔬菜、农作物、植物的枝叶、根部，造成破坏。', '一些花园害虫在取食时造成的伤口、分泌物、排泄物在温暖潮湿的情况下还可诱发软腐病、镰刀菌等多重病害。', '一些花园害虫会分泌臭液、发出叫声，会对人们生活造成滋扰。', '对人体没有直接危害，但若被叮咬或攻击，有可能引起过敏、中毒反应，威胁人们健康。']
                  }
                ],
                img: '3-22.jpg',
                fuget_id: '573'
              },
              {
                title: '花园害虫的防治建议',
                mes: [
                  {
                    type: '',
                    text: ['窗户装细目纱窗，门窗勿处于长期开放状态，阻挡害虫进入室内。', '保持清洁和室内干燥通风，定期检查花盆、水槽等处是否有积水污垢。', '浴室使用完后应开排风扇、窗户等进行通风，勿使浴室长期处于湿润的空气中。', '定期对外围绿化进行预防性广谱除虫，对房屋周围边界区域，如踢脚线、门窗、走廊进行边界预防处理，设置化学防护带。']
                  }
                ],
                img: '4-3.jpg',
                fuget_id: '562'
              }
            ]
          },
        ]
      }
    },
    methods: {
      getMesDetail (num, title) {
        this.$parent.getMesDetail(num, title);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pest_advice.vue